'use client';
import { DropdownMenuSelect, FormControl } from '@baseball-near-you/ui';
import { useFormContext } from 'react-hook-form';

export enum ReferralSource {
  Google = 'Google',
  SocialMedia = 'Social media',
  WordOfMouth = 'Word of mouth',
  Other = 'Other',
}

export function FormReferralSourceDropdown(props: { name: string }) {
  const { setValue, watch } = useFormContext();
  const value = watch(props.name);
  return (
    <FormControl name={props.name} label="How did you hear about us?">
      <ReferralSourceDropdown
        val={value}
        onSelect={(val) => setValue(props.name, val)}
      />
    </FormControl>
  );
}

export function ReferralSourceDropdown(props: {
  onSelect: (val: ReferralSource) => void;
  val: ReferralSource;
}) {
  return (
    <DropdownMenuSelect
      onSelect={(sel) => props.onSelect(sel as ReferralSource)}
      val={props.val}
      values={Object.values(ReferralSource)}
      defaultLabel="Select a source"
    />
  );
}
